import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { format, differenceInCalendarDays } from "date-fns";
import { lt } from "date-fns/locale";
import ReservationForm from "../../components/Forms/ReservationForm/ReservationForm";
import CalendarIcon from "../../images/Calendar-icon.svg";
import LocationIcon from "../../images/Location-icon.svg";
import EuroIcon from "../../images/Euro-icon.svg";
import "./ReservationPage.scss";

const ReservationPage: React.FC = () => {
  const location = useLocation();
  const parkingDate = location.state && location.state.parkingDate;
  const emptySpot = location.state && location.state.emptySpot;
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [carPlate, setCarPlate] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [agreeWithRules, setAgreeWithRules] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [paymentHtml, setPaymentHtml] = useState<string>("");
  const goBack = () => {
    navigate("/");
  };

  const toUTCDate = (date: Date) => {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
  };

  const startDateUTC = toUTCDate(new Date(parkingDate[0].startDate));
  const endDateUTC = toUTCDate(new Date(parkingDate[0].endDate));

  const daysBooked = differenceInCalendarDays(endDateUTC, startDateUTC) + 1;

  const pricePerDay = daysBooked >= 14 ? 3.8 : daysBooked >= 6 ? 4 : 4.4;

  const calculatePrice = (): number => {
    const price = daysBooked * pricePerDay;

    return Math.round(price * 100) / 100;
  };

  const totalPrice = calculatePrice();

  const toggleModal = () => {
    setShowModal(!showModal);
  };
  return (
    <div id="reservation-page">
      <div className="reservation-content-container">
        <h1>Rezervacijos informacija</h1>
        <div className="reservation-container">
          <div className="reservation-info">
            <div className="info-item">
              <img src={CalendarIcon} alt="" className="info-icon" />
              <div className="info-text">
                <span className="label">Atvykimas (nuo)</span>
                <span className="value">
                  {format(
                    new Date(parkingDate[0].startDate),
                    "yyyy 'm.' MMMM d.",
                    { locale: lt }
                  )}{" "}
                  00:00
                </span>
              </div>
            </div>

            <div className="info-item">
              <img src={CalendarIcon} alt="" className="info-icon" />
              <div className="info-text">
                <span className="label">Išvykimas (iki)</span>
                <span className="value">
                  {format(
                    new Date(parkingDate[0].endDate),
                    "yyyy 'm.' MMMM d.",
                    { locale: lt }
                  )}{" "}
                  23:59
                </span>
              </div>
            </div>

            <div className="info-item">
              <img src={LocationIcon} alt="" className="info-icon" />
              <div className="info-text">
                <span className="label">Vieta</span>
                <span className="value">Tulpių g. 20B, Karmėlava</span>
              </div>
            </div>

            <div className="info-item">
              <img src={EuroIcon} alt="" className="info-icon" />
              <div className="info-text">
                <span className="label">Iš viso ({daysBooked} d.)</span>
                <span className="value price">€{totalPrice.toFixed(2)}</span>
              </div>
            </div>

            <div className="reservation-actions">
              <button className="change-dates-btn" onClick={goBack}>
                Keisti datas
              </button>
            </div>
          </div>
        </div>
        <div className="reservation-container">
          <ReservationForm
            name={name}
            setName={setName}
            carPlate={carPlate}
            setCarPlate={setCarPlate}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            email={email}
            setEmail={setEmail}
            agreeWithRules={agreeWithRules}
            setAgreeWithRules={setAgreeWithRules}
            pricePerDay={pricePerDay}
            parkingDate={parkingDate}
            showModal={showModal}
            toggleModal={toggleModal}
            totalPrice={totalPrice}
            emptySpot={emptySpot}
            goBack={goBack}
          />
        </div>
      </div>
      {paymentHtml && <div dangerouslySetInnerHTML={{ __html: paymentHtml }} />}
    </div>
  );
};

export default ReservationPage;
